import React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import {
  CssDataJacketButton,
  CssDataJacketTitleTypography,
} from "../../styles/styled";
import { Divider } from "@mui/material";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "transparent",
  textAlign: "center",
  color: theme.palette.text.secondary,
  boxShadow: "none",
}));

const CssTypography = styled(Typography)({
  color: "white",
});

const CssButton = styled(Button)({
  marginTop: "8px",
  display: "block",
  position: "absolute",
  right: 16,
  width: "5px",
  height: "35px",
  backgroundColor: "grey",
});

export function DataJacketSelectNodeModal({
  open,
  setOpen,
  displayFilterNode,
  nodeInfo,
  setMoveFlag,
}) {
  const handleClose = () => setOpen(false);
  const [filterNode, setFilterNode] = React.useState([]);
  const [topNode, setTopNode] = React.useState(false);
  const [childOpen, setChildOpen] = React.useState(false);
  function handleEachNodeCheckChange(event) {
    if (event.target.checked) {
      if (filterNode.length === 20) {
        setChildOpen(true);
      } else {
        setFilterNode(
          filterNode.length > 0
            ? [...filterNode, event.target.id]
            : [event.target.id]
        );
      }
    } else {
      setFilterNode(filterNode.filter((id) => id !== event.target.id));
    }
  }
  function handleAllNodeCheckChange(event) {
    setTopNode(event.target.checked);
  }

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "relative",
            height: "100%",
          }}
        >
          <Box
            style={{ color: "white" }}
            sx={{
              borderColor: "#666666",
              borderWidth: "1px",
              borderStyle: "solid",
              position: "relative",
              backgroundColor: "#303234",
              width: "50%",
              display: "flex",
              flexDirection: "column",
              margin: "auto",
              marginTop: "100px",
            }}
          >
            <Box style={{ height: "50px", backgroundColor: "#373737" }}>
              <Stack direction="row" spacing={2}>
                <Item>
                  <CssDataJacketTitleTypography style={{ marginLeft: "32px" }}>
                    ノード選択
                  </CssDataJacketTitleTypography>
                </Item>
                <Item>
                  <CssButton
                    onClick={handleClose}
                    style={{ margin: "8px 8px 8px 8px" }}
                  >
                    <CloseIcon style={{ color: "white" }} />
                  </CssButton>
                </Item>
              </Stack>
            </Box>
            <Box
              style={{
                marginTop: "8px",
                height: "65vh",
                overflowY: "scroll",
              }}
            >
              <Grid>
                <CssTypography style={{ marginLeft: "12px" }}>
                  展開するノード（データジャケット）を選択してください（20個まで）
                </CssTypography>
              </Grid>
              {nodeInfo.map((node, index) => (
                <Grid>
                  <FormControlLabel
                    style={{
                      color: "white",
                      width: "100%",
                      marginLeft: "auto",
                      marginRight: "auto",
                    }}
                    control={
                      <Checkbox
                        style={{
                          color: "white",
                        }}
                        onChange={(e) => handleEachNodeCheckChange(e)}
                        id={node.node_ids}
                        key={"checkbox-" + node.node_ids}
                        checked={
                          filterNode.filter((id) => id === node.node_ids)
                            .length > 0
                        }
                      />
                    }
                    label={index + 1 + "_" + node.node_names}
                    key={node.node_ids}
                  />
                </Grid>
              ))}
            </Box>
            <Divider style={{ backgroundColor: "white" }} />
            <Box
              style={{
                marginTop: "16px",
                height: "120px",
              }}
            >
              <Grid>
                <FormControlLabel
                  style={{
                    color: "white",
                    width: "100%",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                  control={
                    <Checkbox
                      style={{
                        color: "white",
                      }}
                      onChange={handleAllNodeCheckChange}
                    />
                  }
                  label={
                    "選択したデータジャケット以外も展開する（類似度上位20個まで）"
                  }
                  key={"全データジャケット"}
                />
              </Grid>
              <Grid
                style={{
                  display: "flex",
                  justifyContent: "right",
                  marginTop: "16px",
                }}
              >
                <CssDataJacketButton
                  variant="contained"
                  size="large"
                  color="success"
                  style={{
                    width: "100px",
                    marginRight: "16px",
                  }}
                  onClick={() => {
                    var resultNode = [];
                    if (topNode === true) {
                      resultNode = nodeInfo
                        .filter((node) => !filterNode.includes(node.node_ids))
                        .map((node, index) => {
                          if (index < 20 - filterNode.length)
                            return node.node_ids;
                        });
                      resultNode = filterNode.concat(
                        resultNode.filter(
                          (node) => node !== "" && node !== undefined
                        )
                      );
                    } else {
                      resultNode = filterNode;
                    }
                    displayFilterNode(resultNode);
                    setFilterNode([]);
                    setTopNode(false);
                    setMoveFlag(true);
                  }}
                >
                  展開
                </CssDataJacketButton>
              </Grid>
            </Box>
          </Box>
          {childOpen && (
            <ChildModal
              open={childOpen}
              setOpen={setChildOpen}
              message={"展開するデータジャケットが20個までです。"}
            />
          )}
        </Box>
      </Modal>
    </>
  );
}

export function ChildModal({ open, setOpen, message }) {
  const handleClose = () => setOpen(!open);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
    >
      <Box
        sx={{
          position: "relative",
        }}
      >
        <Box
          style={{ color: "white" }}
          sx={{
            border: "solid 1px #666666",
            position: "relative",
            backgroundColor: "#303234",
            width: "40%",
            display: "flex",
            flexDirection: "column",
            margin: "auto",
            marginTop: "100px",
          }}
        >
          <Box style={{ height: "50px", backgroundColor: "#373737" }}>
            <Stack direction="row" spacing={2}>
              <Item>
                <CssDataJacketTitleTypography style={{ marginLeft: "32px" }}>
                  エラーメッセージ
                </CssDataJacketTitleTypography>
              </Item>
              <Item>
                <CssButton
                  onClick={handleClose}
                  style={{ margin: "8px 8px 8px 8px" }}
                >
                  <CloseIcon style={{ color: "white" }} />
                </CssButton>
              </Item>
            </Stack>
          </Box>
          <CssTypography
            id="child-modal-description"
            style={{ margin: "32px 32px" }}
          >
            {message}
          </CssTypography>
        </Box>
      </Box>
    </Modal>
  );
}
